/* This component is auto-generated with figma-svg. */
export enum SocialView {
    Vk = 'Vk',
    Yandex = 'Yandex',
    Google = 'Google',
    M = 'M',
    Livejournal = 'Livejournal',
    Android = 'Android',
    Linkedin = 'Linkedin',
    Imessage = 'Imessage',
    Apple = 'Apple',
    Github = 'Github',
    Instagram = 'Instagram',
    Facebook = 'Facebook',
    Fl = 'Fl',
    Esia = 'Esia',
    Skype = 'Skype',
    Telegram = 'Telegram',
    Ok = 'Ok',
    Whatsapp = 'Whatsapp',
    Twitter = 'Twitter',
    Icq = 'Icq',
    Mail = 'Mail',
    Viber = 'Viber',
    Dnr = 'Dnr',
    Stackoverflow = 'Stackoverflow',
    Tinkoff = 'Tinkoff',
}

export interface SocialVk {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Default | SocialAppearance.Color | SocialAppearance.Outlined;
    view: SocialView.Vk;
}
export interface SocialYandex {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Color | SocialAppearance.Default;
    view: SocialView.Yandex;
}
export interface SocialGoogle {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Default | SocialAppearance.Color;
    view: SocialView.Google;
}
export interface SocialM {
    scale: SocialScale.Small | SocialScale.Medium;
    view: SocialView.M;
}
export interface SocialLivejournal {
    scale: SocialScale.Small | SocialScale.Medium;
    view: SocialView.Livejournal;
}
export interface SocialAndroid {
    scale: SocialScale.Small | SocialScale.Medium;
    appearance: SocialAppearance.Default | SocialAppearance.Color;
    view: SocialView.Android;
}
export interface SocialLinkedin {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Default | SocialAppearance.Color;
    view: SocialView.Linkedin;
}
export interface SocialImessage {
    scale: SocialScale.Medium | SocialScale.Small;
    view: SocialView.Imessage;
}
export interface SocialApple {
    scale: SocialScale.Small | SocialScale.Medium;
    view: SocialView.Apple;
}
export interface SocialGithub {
    scale: SocialScale.Medium | SocialScale.Small;
    view: SocialView.Github;
}
export interface SocialInstagram {
    scale: SocialScale.Small | SocialScale.Medium;
    appearance: SocialAppearance.Outlined | SocialAppearance.Default | SocialAppearance.Color;
    view: SocialView.Instagram;
}
export interface SocialFacebook {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Outlined | SocialAppearance.Default | SocialAppearance.Color;
    view: SocialView.Facebook;
}
export interface SocialFl {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Color | SocialAppearance.Default;
    view: SocialView.Fl;
}
export interface SocialEsia {
    scale: SocialScale.Small | SocialScale.Medium;
    appearance: SocialAppearance.Color | SocialAppearance.Default;
    view: SocialView.Esia;
}
export interface SocialSkype {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Default | SocialAppearance.Color;
    view: SocialView.Skype;
}
export interface SocialTelegram {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Color | SocialAppearance.Default | SocialAppearance.Outlined;
    view: SocialView.Telegram;
}
export interface SocialOk {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Default | SocialAppearance.Outlined | SocialAppearance.Color;
    view: SocialView.Ok;
}
export interface SocialWhatsapp {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Color | SocialAppearance.Outlined | SocialAppearance.Default;
    view: SocialView.Whatsapp;
}
export interface SocialTwitter {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Color | SocialAppearance.Default | SocialAppearance.Outlined;
    view: SocialView.Twitter;
}
export interface SocialIcq {
    scale: SocialScale.Small | SocialScale.Medium;
    appearance: SocialAppearance.Default | SocialAppearance.Color;
    view: SocialView.Icq;
}
export interface SocialMail {
    scale: SocialScale.Small | SocialScale.Medium;
    appearance: SocialAppearance.Color | SocialAppearance.Default;
    view: SocialView.Mail;
}
export interface SocialViber {
    scale: SocialScale.Small | SocialScale.Medium;
    appearance: SocialAppearance.Color | SocialAppearance.Outlined | SocialAppearance.Default;
    view: SocialView.Viber;
}
export interface SocialDnr {
    scale: SocialScale.Small | SocialScale.Medium;
    appearance: SocialAppearance.Default | SocialAppearance.Color;
    view: SocialView.Dnr;
}
export interface SocialStackoverflow {
    scale: SocialScale.Medium | SocialScale.Small;
    view: SocialView.Stackoverflow;
}
export interface SocialTinkoff {
    scale: SocialScale.Medium | SocialScale.Small;
    appearance: SocialAppearance.Label | SocialAppearance.Default;
    view: SocialView.Tinkoff;
}

export type SocialInvariants =
    | SocialVk
    | SocialYandex
    | SocialGoogle
    | SocialM
    | SocialLivejournal
    | SocialAndroid
    | SocialLinkedin
    | SocialImessage
    | SocialApple
    | SocialGithub
    | SocialInstagram
    | SocialFacebook
    | SocialFl
    | SocialEsia
    | SocialSkype
    | SocialTelegram
    | SocialOk
    | SocialWhatsapp
    | SocialTwitter
    | SocialIcq
    | SocialMail
    | SocialViber
    | SocialDnr
    | SocialStackoverflow
    | SocialTinkoff;

export enum SocialScale {
    Medium = 'Medium',
    Small = 'Small',
}
export enum SocialAppearance {
    Default = 'Default',
    Color = 'Color',
    Outlined = 'Outlined',
    Label = 'Label',
}
